import TestSerializer from "../serializers/TestSerializer";
import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";

export default class TestRepository {
  TEST_BASE = "/api/basic";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async testRequest(instance, id) {
    const token = await getToken(instance);
    const path = `${this.TEST_BASE}?id=${id}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(TestSerializer.deSerialize(
      req
    ));
  }
}